import Vue from 'vue'
import index from './index.vue'
import '../base/common'

new Vue({
  data() {
    return {
      state: {}
    }
  },
  created() {
    Vue.prototype.$state = this.state
  },
  render: h => h(index)
}).$mount('#app')
